<template>
	<div class="index nobg" v-loading="loading">
		<HeaderInc ref="ref_header" :info="info"></HeaderInc>
		<div class="warp main_body">
			<div class="left_mune">
				<ul>
					<li @click="gohome">
						<img src="../assets/ico_3.png" />
						个人设置
					</li>
					<li class="active">
						<img src="../assets/ico_4.png" />
						作品管理
					</li>
					<li @click="gocer">
						<img src="../assets/ico_7.png" />
						证书查询
					</li>
				</ul>
			</div>
			<div class="main_content">
				<h1>>作品管理</h1>
				<div class="main_content_g">
					<el-table :data="tableData" style="width: 100%">
						<el-table-column prop="id" label="ID" width="100" />
						<el-table-column prop="work_code" label="作品编号" width="200" />
						<el-table-column prop="match_title" label="赛场" width="200" />
						<el-table-column prop="title" label="主题" width="200" />
						<el-table-column label="状态" width="100">
							<template #default="scope">
								<span>{{status_option[scope.row.status]}}</span>
							</template>
						</el-table-column>
						<el-table-column label="报名" width="100">
							<template #default="scope">
								<span>{{paystatus_option[scope.row.paystatus]}}</span>
							</template>
						</el-table-column>
						
						<el-table-column label="参赛费" width="100">
							<template #default="scope">
								<span>{{hexiao_option[scope.row.hexiao]}}</span>
							</template>
						</el-table-column>
						
						<el-table-column label="提交时间" width="120">
							<template #default="scope">
								<span>{{fmtday(scope.row.createtime)}}</span>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="240">
							<template #default="scope">
								<a v-show="scope.row.hexiao == '0' && zsh(scope.row.wtype) > 1 && (scope.row.college_id == 0 || (scope.row.college_id > 0 && scope.row.status == 1) || (scope.row.college_id > 0 && scope.row.status == 2 && scope.row.paystatus == 1 && scope.row.isme == 1))" class="button_1 mini" @click="work_pay(scope.$index)">支付</a>
								<a class="button_1 mini" v-show="scope.row.hexiao == '0'" @click="work_edit(scope.$index)">编辑</a>
								<a class="button_1 mini" v-show="scope.row.hexiao == '1'" @click="work_edit(scope.$index)">查看</a>
								<a v-show="scope.row.hexiao == '1' || scope.row.wtype == '1'" class="button_2 mini" @click="work_del(scope.$index)">删除</a>
							</template>
						</el-table-column>
					</el-table>
					
					<div class="workadd" @click="addwork"></div>
					
				</div>
			</div>
		</div>
		
		<el-dialog v-model="centerDialogVisible" title="微信支付" width="30%" destroy-on-close center>
			<div class="info_contact">
				<vue-qr :logoSrc="imageUrl" :text="paycode" :size="300"></vue-qr>
				<span class="text-center">请使用微信扫码支付~</span>
				<span class="text-center">重要提示：一旦支付成功，作品不可修改、不可删除！~</span>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button type="success" @click="payover">支付完成</el-button>
					<el-button @click="centerDialogVisible = false">关闭</el-button>
				</span>
			</template>
		</el-dialog>
		
	</div>
</template>

<script>
	import httpUtil from '@/util/HttpRequestUtil'
	import HeaderInc from '@/components/HeaderInc.vue'
	import vueQr from 'vue-qr/src/packages/vue-qr.vue'
	export default {
		name: 'Work',
		components: {
			HeaderInc,
			vueQr
		},
		props: {},
		data() {
			return {
				imageUrl: require("../assets/small_logo.png"),
				loading: true,
				type: 0,
				options: [{
						label: '全部',
						value: 0
					},
					{
						label: '图片',
						value: 1
					},
					{
						label: '音频视频',
						value: 2
					},
					{
						label: '论文',
						value: 3
					}
				],
				mywork: [],
				info: {
					token: '',
					avatar: '',
					name: ''
				},
				tableData: [],
				status_option: ['待审核', '退回', '通过'],
				paystatus_option: ['未报名', '已报名'],
				hexiao_option: ['待缴费', '已缴费'],
				centerDialogVisible:false,
				paycode:''
			}
		},
		created() {
			this.getuserdata()
		},
		updated() {

		},
		activated() {
			this.getworklist()
		},
		methods: {
			addwork() {
				var that = this
				that.$router.push({
					name: 'Workadd'
				})
			},
			goinfo() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Info'
				})
			},
			getuserdata() {
				var that = this
				var userinfo = JSON.parse(localStorage.getItem('userinfo')) || [];
				if (!userinfo.token) {
					that.gologin()
					return false
				}
				let data = {}
				data.ac = 'getuserinfo'
				data.token = userinfo.token
				httpUtil.post('/api/', data, function(res) {
					if (res) {
						if(res.status == 1){
						that.info = res
						that.info.type = parseInt(res.type)
						that.loading = false
						}else{
							that.$message.error('请先完成注册~')
							that.gohome()
						}
					} else {
						that.gologin()
						return false
					}
				})
			},
			gologin() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Index'
				})
			},
			gohome() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Home'
				})
			},
			getworklist() {
				var that = this
				var userinfo = JSON.parse(localStorage.getItem('userinfo')) || [];
				if (!userinfo.token) {
					that.gologin()
					return false
				}
				let data = {}
				data.ac = "getworklist"
				data.token = userinfo.token
				httpUtil.post('/api/', data, function(res) {
					if (res.length > 0) {
						that.tableData = res
					} else {
						that.tableData = []
					}
				})
			},
			work_del(index) {
				var that = this
				that.$confirm('你确定删除作品吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let data = {}
					data.ac = "work_del"
					data.token = that.info.token
					data.id = that.tableData[index].id
					httpUtil.post('/api/', data, function(res) {
						if (res.status == 1) {
							that.$message({
								showClose: true,
								message: res.msg,
								type: 'success'
							})
							that.tableData.splice(index,1)
						} else {
							that.$message.error(res.msg)
						}
					})
				}).catch((err) => {
				
				})
			},
			fmtday(time) {
				time = time * 1000
				let date = new Date(time)
				return httpUtil.formatDate(date, 'yyyy-MM-dd')
			},
			work_edit(index) {
				var that = this
				that.$router.push({
					name: 'Workadd',
					query: {
						work_id: that.tableData[index].id,
					}
				})
			},
			zsh(txt){
				return parseInt(txt)
			},
			work_pay(index){
				var that = this
				let data = {}
				data.ac = 'myself'
				data.work_code = that.tableData[index].work_code
				httpUtil.post('/pay/', data, function(res) {
					if(res.status){
						that.centerDialogVisible = true
						that.paycode = res.code_url
					}else{
						that.$message.error(res.msg)
					}
				})
			},
			payover(){
				var that = this
				that.getworklist()
				that.centerDialogVisible = false
			},
			gocer(){
				var that = this
				that.$router.push({
					name: 'Cer'
				})
			}
		},

	}
</script>

<style>
	.workadd{
		width: 92px;
		height: 92px;
		display: block;
		margin: 30px auto;
		background: url(../assets/ico_6.png) no-repeat center;
		cursor: pointer;
	}
	.mini {
		width: 60px;
		display: inline-block;
		margin: 0 5px;
	}
	
	.info_contact img{
		display: block !important;
		margin: 10px auto;
	}
	
	.info_contact span.text-center{
		display: block;
		text-align: center;
	}
</style>
